import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=bcbd1916"
import script from "./AdminDetails.vue?vue&type=script&lang=js"
export * from "./AdminDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports